export default __webpack_public_path__ + "static/media/git.5c02aabb.svg";